const getPartnerData = (rootState) => rootState.partner;

export default getPartnerData;
